var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2232",
    d: "M0-682.665H14v14H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69162",
    "data-name": "Group 69162",
    transform: "translate(17407 -6179)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16030",
    "data-name": "Rectangle 16030",
    width: 16,
    height: 16,
    transform: "translate(-17407 6179)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2226",
    transform: "translate(-17406 6862.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2228",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2230",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2236",
    transform: "translate(0.41 0.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2238",
    d: "M-110.906-621.3h-2.322v-2.322l10.686-10.686,2.322,2.322Z",
    transform: "translate(113.228 634.31)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2240",
    transform: "translate(9.355 -680.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2242",
    d: "M0,0,2.322,2.322",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2244",
    transform: "translate(8.194 -679.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2246",
    d: "M0,0,2.322,2.322",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2248",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2250",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2256",
    transform: "translate(4.885 13.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2258",
    d: "M0,0H9.115",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.5a587d73f81801f1ca60ba45c9974504.svg";
export { ForwardRef as ReactComponent };